import { AddressFormVariant, VariantConfig } from './types';

/**
 * Visual presentation configurations for each checkout variant.
 * Controls heading text, styling, and spacing.
 */
export const VARIANT_CONFIGS: Record<AddressFormVariant, VariantConfig> = {
  checkout: {
    fieldsetClassName: 'mb-5',
    showHeading: true,
    headingConfig: {
      legendClassName: 'mb-0',
      headingClassName: 'h5',
      messageId: 'payment.card.holder.information.form.heading',
      defaultMessage: 'Card Holder Information',
    },
  },
  'checkout-simplified': {
    fieldsetClassName: 'mb-3 mt-4',
    showHeading: true,
    headingConfig: {
      legendClassName: 'mb-2',
      headingClassName: 'h5',
      messageId: 'payment.card.holder.information.form.heading',
      defaultMessage: 'Billing information',
    },
  },
  'checkout-stepper': {
    fieldsetClassName: '',
    showHeading: false,
  },
  'checkout-test': {
    fieldsetClassName: 'mb-5',
    showHeading: true,
    headingConfig: {
      legendClassName: 'mb-0',
      headingClassName: 'h5',
      messageId: 'payment.card.holder.information.form.heading',
      defaultMessage: 'Card Holder Information',
    },
  },
};

/**
 * Configuration for country-specific fields in short form mode.
 * Defines which fields to show for each country's address format.
 *
 * - US: Postal code only (state can be inferred from ZIP)
 * - CA: State + postal code (both required for Canadian addresses)
 * - IN: State only (PIN codes not collected in short form)
 * - Other: No additional fields
 */
export const SHORT_FORM_CONFIG_BY_COUNTRY: Record<
  string,
  { showState: boolean; showPostal: boolean }
> = {
  US: { showState: false, showPostal: true },
  CA: { showState: true, showPostal: true },
  IN: { showState: true, showPostal: false },
};
